import { Controller } from "stimulus"

export default class extends Controller {
  static values = { url: String }

  connect() {
    this.intervalID = setInterval(() => fetch(this.urlValue), 600000)
  }

  disconnect() {
    clearInterval(this.intervalID)
  }
}
